import { SampleItem, TMinMaxValues, TSensorDataResponse } from "../../services/sensorData.service";


export type TGraphData = Array<SampleItem> | Array<TDiseasePestData>;

export type TDiseasePestData = {
  probability: number;
  riskLevel: string;
  date: string;
  calculatedDate?: string;
  color?:string
} 


export type TChartData = {
  min: TMinMaxValues;
  max: TMinMaxValues;
  avg: number;
  normalRange: TGraphData,
  sum?: number;
}

type TLabel = string;
export type TDataset = {
  label: TLabel;
  data: Array<number>;
  backgroundColor: Array<string> | string;
  borderColor?: Array<string> | string;
  borderWidth?: number;
  pointBorderColor?:Array<string>;
  pointBackgroundColor?:Array<string>;
  pointRadius?:number;
  tension?: number;
  fill?: string;
};
export type TDatasets = Array<TDataset>;
export type TLabels = Array<TLabel>;
export type TOptions = {
  scales?: {
    x?: {
      title?: {
        text?: string;
        display?: boolean;
      };
      ticks?: {
        autoSkip?: boolean;
        maxTicksLimit?: number;
      };
    };
    y?: {
      beginAtZero?: boolean;
    };
  };
};


export type TCustomProcessFn = (
  graphData: TSensorDataResponse,
  startDate: string,
  endDate: string
) => {
  sample: Array<SampleItem>;
  min: TMinMaxValues;
  max: TMinMaxValues;
  avg: number;
  color?:Array<string>;
};

export enum DateDisableStrategies {
  "doNotDisable" = "doNotDisable",
  "disableFutureDates" = "disableFutureDates"
}

type TTableRow = Array<string | number>;

export type TTableData = Array<TTableRow>;